import React from 'react';
import { connect } from 'react-redux';

import PropTypes from 'prop-types';

import { SpinnerLottie } from 'apps/promo/components/common/SpinnerLottie/SpinnerLottie';
import clsx from 'clsx';

import styles from './PromoSpinner.module.css';
import { PromoText } from '../promo-text/PromoText';
import { PromoRow } from '../PromoRow/PromoRow';

const PromoSpinner = ({ forceShow = false, ...props }) => {
    if (!props.isShowSpinner && !forceShow) {
        return null;
    }

    const className = clsx(styles.spinnerOverlay, props.insidePopup && styles.spinnerOverlayInsidePopup);

    return (
        <div className={className}>
            <div className={styles.spinnerContainer}>
                <PromoRow indent={props.isEmptyText ? null : '24px'}>
                    <SpinnerLottie />
                </PromoRow>

                {!props.isEmptyText && (props.siteSpinnerText || props.customSpinnerText) && (
                    <PromoText tag="p" variant="subheader">
                        {props.customSpinnerText || props.siteSpinnerText}
                    </PromoText>
                )}
            </div>
        </div>
    );
};

PromoSpinner.propTypes = {
    insidePopup: PropTypes.bool,
};

const mapStateToProps = (state) => ({
    isShowSpinner: state.app.isShowSpinner,
    siteSpinnerText: state.extra.noAuthFooter?.messages?.siteSpinnerText,
});

export default connect(mapStateToProps)(PromoSpinner);
